import React from 'react';
import {
    Button,
    FormFeedback,
    Form,
    FormGroup,
    Label,
    Input, Navbar, NavbarBrand
} from 'reactstrap';
import {setTitle} from "./util";

class ManufacturerSubscribe extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        };

        setTitle('Unauthorized');
    }

    componentWillMount() {
    }


    componentDidMount() {
    }

    render() {
        return (
            <div className="mx-auto">
                <div>
                    <Navbar color="light" light expand>
                        <NavbarBrand className="mfg-title">
                            DDX SmartBrush - Portal
                        </NavbarBrand>
                        <span className="ml-auto">
                            <img alt="DDX logo" src="/ddx.png" width={96} height={37} />
                        </span>
                    </Navbar>
                </div>

                <br />
                <div className="mfg-login d-flex flex-column mx-auto">
                    <h4>
                        You are currently not subscribed to DDX SmartBrush data services and can not access these features.
                        <br />
                        To learn more and sign up, call 1-801-847-4625
                    </h4>
                </div>
            </div>
        );
    }
}

export default ManufacturerSubscribe;